import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { firestore } from '../../../../firebase'

function TopLeagues({ topLeaguesFB, setTopLeaguesFB }) {
    const [leagues, setLeagues] = useState([])

    useEffect(() => {
        try {
            const leaguesRef = firestore.collection('top-leagues')
            leaguesRef.orderBy('order').onSnapshot(({ docs }) => {
                const leagues = docs.map((doc) => {
                    const leagues = { id: doc.id, ...doc.data() }
                    return leagues
                })
                setLeagues(leagues)
                if (setTopLeaguesFB) {
                    setTopLeaguesFB(leagues)
                }
            })
        } catch (error) {
            console.log(error)
        }
    }, [])

    return (
        <div>
            {leagues?.map((league, index) => {
                return (
                    <div className="card card-body" key={index}>
                        <div>
                            <Link to={`/leagues/${league.league_id}`}>
                                <img
                                    src={league.league_logo}
                                    alt={league.league_name}
                                    className="teamLogo mr-2"
                                />
                            </Link>
                            <Link to={`/leagues/${league.league_id}`}>
                                {league.league_name}
                            </Link>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
export default TopLeagues
